export default __webpack_public_path__ + "static/set-funnel-time-range-light-mode-9f533ba955eb5ebf03122aa3b3b3bb78.png";